import { useEffect } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'
import { LogIn, LogOut, Menu, Moon, Sun } from 'lucide-react'
import { useAuth } from '../../contexts/AuthContext'
import { useTheme } from '../../contexts/ThemeContext'
import { seitentitel } from './navigation'
import Suche from './Suche'

interface Props {
  navOffen: boolean
  onMenu: () => void
}

export default function Topbar({ navOffen, onMenu }: Props) {
  const { pathname } = useLocation()
  const { user, isAuthenticated, isAdmin, logout } = useAuth()
  // Admin-Seiten verraet der Titel nur dem Admin (s. Zugang.tsx).
  const titel = seitentitel(pathname, isAdmin)
  const { theme, toggleTheme } = useTheme()
  const navigate = useNavigate()
  const client = useQueryClient()

  useEffect(() => {
    document.title = titel === 'Qualyz' ? 'Qualyz' : `${titel} · Qualyz`
  }, [titel])

  const name = user?.first_name || user?.email?.split('@')[0] || ''

  const abmelden = () => {
    logout()
    // Persoenliches (Watchlist) darf nach dem Abmelden nicht im Speicher bleiben.
    client.clear()
    navigate('/')
  }

  return (
    <header className="q-topbar">
      <button
        type="button"
        className="q-burger"
        onClick={onMenu}
        aria-label={navOffen ? 'Menü schließen' : 'Menü öffnen'}
        aria-expanded={navOffen}
        aria-controls="q-sidebar"
      >
        <Menu aria-hidden="true" />
      </button>

      <h1 className="q-pagetitle">{titel}</h1>

      <Suche />

      <div className="q-topbar-actions">
        <button
          type="button"
          className="q-iconbtn"
          onClick={toggleTheme}
          aria-label={theme === 'light' ? 'Dunkles Design' : 'Helles Design'}
          title={theme === 'light' ? 'Dunkles Design' : 'Helles Design'}
        >
          {theme === 'light' ? <Moon aria-hidden="true" /> : <Sun aria-hidden="true" />}
        </button>

        {isAuthenticated ? (
          <>
            {/* Der Name fuehrt zum eigenen Konto -- dort steht das Passwort. */}
            <Link to="/konto" className="q-user" title={`${user?.email ?? ''} · Mein Konto`}>
              {name}
            </Link>
            <button type="button" className="q-btn q-btn-ghost q-btn-sm" onClick={abmelden}>
              <LogOut aria-hidden="true" />
              <span className="q-hide-sm">Abmelden</span>
            </button>
          </>
        ) : (
          <Link to="/login" className="q-btn q-btn-primary q-btn-sm">
            <LogIn aria-hidden="true" />
            <span>Anmelden</span>
          </Link>
        )}
      </div>
    </header>
  )
}
